<template>
  <div class="">
    <div v-for="(item, i) in list" :key="i">
      <person-extra-work-list-mob-item @onClickItem="handleClick" :item="item" />
    </div>
  </div>
</template>

<script>
import PersonExtraWorkListMobItem from './PersonExtraWorkListMobItem.vue';
export default {
  components: { PersonExtraWorkListMobItem },
  props: {
    list: Array,
  },
  computed: {},
  data() {
    return {
      show: false,
    };
  },
 methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}

.card-text {
  font-size: 0.875rem !important;
  color: var(--black) !important;
}

.text-caption-color {
  color: #8b8b8b;
}

.state .v-icon {
  font-size: 1rem;
}
</style>